<template>
  <div class="vx-card p-6">
    <div class="flex flex-wrap" style="  font-size: 40px; justify-content: center;">
      MALİYET İZLEME
    </div>
    <div class="flex flex-wrap items-center">
      <!-- ITEMS PER PAGE -->
      <div class="flex-grow">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">
              {{ currentPage * paginationPageSize - (paginationPageSize - 1) }}
              -
              {{ productStockList.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : productStockList.length }}
              of {{ productStockList.length }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
              <span>30</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>

    <div class="row">
      <div class="col" style="width: 30%; display: inline-block; vertical-align: top;">
        <ag-grid-vue
          style="height: 49vh;"
          ref="agGridTable"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="productStockList"
          rowSelection="single"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :rowClassRules="rowClassRules"
          @selectionChanged="selectionChanged"
        ></ag-grid-vue>
        <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
      </div>

      <div class="col" style="width: 60%; vertical-align: top; display: inline-block; height: 750px; overflow-y: scroll;">
        <form id="app" style="width: 90%;">
          <div class="ml-10" style="width: 100%;">
            <div class="" style="margin-top: 70px; width: 100%; vertical-align: middle; display: flex;">
              <div class="col" style="width: 5%;">
                <label><b>Talep ID</b></label>
              </div>
              <div class="col" style="width: 10%;">
                <label><b>Talep Tar</b></label>
              </div>
              <div class="col" style="width: 7%;">
                <label><b>Birim Fiyat</b></label>
              </div>
              <div class="col" style="width: 5%;">
                <label><b>Kur</b></label>
              </div>
              <div class="col" style="width: 10%;">
                <label><b>Birim TL</b></label>
              </div>
              <div class="col" style="width: 10%;">
                <label><b>Navlun Masraf</b></label>
              </div>
              <div class="col" style="width: 10%;">
                <label><b>Diğer Masraf</b></label>
              </div>
              <div class="col" style="width: 10%;">
                <label><b>Toplam Bedel</b></label>
              </div>
              <div class="col" style="width: 5%;">
                <label><b>Ağırlık</b></label>
              </div>
              <div class="col" style="width: 10%;">
                <label><b>Toplam Ağırlık</b></label>
              </div>
              <div class="col" style="width: 10%;">
                <label><b>Brüt Maaliyet</b></label>
              </div>
              <div class="col" style="width: 10%;">
                <label><b>Maliyete Yansıt</b></label>
              </div>
            </div>

            <div class="col mt-5" v-for="item in this.productCostList" :key="item.purchaseId" style="width: 100%; display: inline-block; vertical-align: middle; display: flex;">
              <div class="col" style="width: 5%;">
                <label>{{ item.purchaseId }}</label>
              </div>
              <div class="col" style="width: 10%;">
                <label>{{ item.purchaseDate.substr(0, 10) }}</label>
              </div>
              <div class="col" style="width: 7%;">
                <label>{{ item.unitPrice + " " + item.currencySymbol }}</label>
              </div>
              <div class="col" style="width: 5%;">
                <label>{{ item.fxRate }}</label>
              </div>
              <div class="col" style="width: 10%;">
                <label>{{ item.productCostTL }}</label>
              </div>
              <div class="col" style="width: 10%;">
                <label>{{ item.freightExpense }}</label>
              </div>
              <div class="col" style="width: 10%;">
                <label>{{ item.otherTotalExpense }}</label>
              </div>
              <div class="col" style="width: 10%;">
                <label>{{ item.totalCostOfPurchase }}</label>
              </div>
              <div class="col" style="width: 5%;">
                <label>{{ item.productWeight }}</label>
              </div>
              <div class="col" style="width: 10%;">
                <label>{{ item.totalWeightOfPurchase }}</label>
              </div>

              <div class="col" style="width: 10%;">
                <label>{{ item.productCostOnThisPurchase }}</label>
              </div>

              <div class="col" style="width: 10%;">
                <vs-button style="margin-top:-7px" class="small" color="danger" @click.stop.prevent="updateProductCostPrice(item)">Maliyete Yansıt</vs-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="ml-10" style="width: 100%;">
        <div class="" style="margin-top: 70px; width: 100%; vertical-align: middle; display: flex;">
          <div class="col" style="width: 5%;">
            <label><b>Product ID</b></label>
          </div>
          <div class="col" style="width: 10%;">
            <label><b>Owning Cost</b></label>
          </div>
          <div class="col" style="width: 10%;">
            <label><b>Sale Price</b></label>
          </div>
         
          </div>
        </div>

        <div class="col mt-5 ml-10" v-for="item in this.productCostList" :key="item.purchaseId" style="width: 100%; display: inline-block; vertical-align: middle; display: flex;">
          <div class="col" style="width: 5%;">
            <label>{{ selectedRow.productId }}</label>
          </div>
          <div class="col" style="width: 10%;">
            <label>{{ selectedRow.owningCost }}</label>
          </div>

          <div class="col" style="width: 5%;">
            <label>{{ selectedRow.salePrice }}</label>
          </div>
         
        </div>
      </div>
    </div>
    <!-- prompt for addnew personnel -->
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { repository } from "@/_services/repository.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

// Cell Renderer

export default {
  components: {
    AgGridVue,
    VuePerfectScrollbar,
  },

  data() {
    return {
      selectedRow: [],
      productStockList: [],
      productCostList: [],
      gridApi: null,
      rowClassRules: null,
      productId: undefined,
      perfectScrollbarSettings: {
        // perfectscrollbar settings
        maxScrollbarLength: 10,
        wheelSpeed: 1,
      },

      gridOptions: { rowHeight: 40 },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      /* eslint-disable */
      columnDefs: [
        {
          headerName: "Ürün Id",
          field: "productId",
          filter: true,
          hide: true,
        },
        {
          headerName: "Ürün Adı",
          field: "productName",
          filter: true,
        },
      ],
    };
  },

  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 12;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    selectionChanged: function() {
      this.selectedRow = this.gridApi.getSelectedRows()[0];
      this.productId = this.selectedRow.productId;

      this.getProductCostByProductId();
    },
    getProductCostByProductId: async function() {
      let costList = await repository.getAll("Purchase/getProductCostByProductId/" + this.productId).then((r) => r.list);
      if (costList) {
        this.productCostList = costList;
      }
    },

    getProductStock: async function() {
      let list = await repository.getAll("Purchase/getProductStock").then((r) => r.list);

      if (list) {
        this.productStockList = list;
      } else {
        this.$vs.notify({
          title: "Ürünler Çekilemedi",
          text: (list && list.hasExceptionError && list.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });

        //Güncelleme için URL den pruchaseId çekiliyor
        if (this.$route.params != null && this.$route.params.purchaseId > 0) {
          this.purchaseId = this.$route.params.purchaseId;
          this.getPurchaseById();
        }
      }
    },

    updateProductCostPrice: async function(item) {
      let owningCost = (item.productCostOnThisPurchase / item.fxRate).toFixed(2);
      let resultConfirm = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: "Brüt Maliyet / Kur = " + owningCost + " " + item.currencySymbol + " tutarı maliyet tutarı olarak sisteme yansıtılacaktır.",
        //input: "text",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm.isConfirmed) {
        this.$vs.loading();
        await repository.postEntity("Product/SaveProduct", { ProductId: item.productId, OwningCostCurrencyId: item.currencyId, OwningCost: owningCost });
        this.$vs.loading.close();
        await this.$swal.fire({ icon: "success", title: "İşlem Başarılı." });
        this.getProductStock();
        return;
      } else {
        return;
      }
    },
  },
  beforeMount() {
    this.rowClassRules = {
      rowColorForNotWorkingPerson: "data.status == false",
      rowColorForMissingInfoPerson: "data.error != null",
    };
  },
  beforeUpdate() {
    this.gridApi.sizeColumnsToFit();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    this.gridApi.sizeColumnsToFit();
  },
  created() {
    this.getProductStock();
  },
};
</script>

<style lang="scss" scoped>
.rowColorForNotWorkingPerson {
  background-color: rgb(255, 235, 235) !important;
}
.rowColorForMissingInfoPerson {
  background-color: rgba(255, 220, 196, 0.795) !important;
}
</style>
